export interface RecruitJob {
  id: number;
  title: string;
  shortTitle: string;
  category: string;
  workStyle: string;
  salary: string;
  salaryNote: string;
  workingHours: string;
  workingHoursNote: string;
  subCopy: string;
  summary: string;
  jobCode: string;
  features: {
    tag: string;
    title: string;
    description: string;
  }[];
  jobDescriptions: {
    title: string;
    description: string;
  }[];
  workStyles: string[];
  requirements: {
    label: string;
    value: string | string[];
    isHighlighted?: boolean;
    type?: 'text' | 'list' | 'checklist' | 'custom';
  }[];
  selectionSteps: {
    step: string;
    title: string;
    description: string;
    isLast?: boolean;
  }[];
  companyProfile: {
    label: string;
    value: string;
    isLink?: boolean;
  }[];
  mailtoSubject: string;
  mailtoBody: string;
}

export const allRecruitJobs: RecruitJob[] = [
  {
    id: 1,
    title: "【完全在宅／未経験OK】定時終業・電話なし！20代活躍中の急成長AI企業でデータ入力・サポート事務｜話題のAIツールも学べる！",
    shortTitle: "データ入力・サポート事務（リモート）",
    category: "バックオフィス・事務",
    workStyle: "完全フルリモート",
    salary: "月給 300,000円〜",
    salaryNote: "（経験・スキル・前職給与を考慮の上決定 / 交通費規定支給）",
    workingHours: "固定時間制 10:00〜19:00",
    workingHoursNote: "（実働8時間・休憩60分 / 残業月0〜5時間程度）",
    subCopy: "フルリモート・定時終業・電話対応いっさい無し！AI研修・コンサルのサポート事務・未経験OK",
    summary: "AI研修・コンサルの受講者データ入力や助成金申請フォーマット管理。ChatGPT Plus等の有料AIツール活用も学べるバックオフィス業務です。",
    jobCode: "JOB #01",
    features: [
      {
        tag: "FEATURE 01",
        title: "電話対応いっさいゼロ＆<br>完全フルリモート",
        description: "社内外とのやり取りはLINEやSlackなどのチャットツールが中心です。電話の受電対応による突発的な業務中断がなく、モクモクと自分のペースで作業に集中できます。"
      },
      {
        tag: "FEATURE 02",
        title: "20代中心のフラット＆<br>質問しやすいオープン環境",
        description: "部署平均年齢は26歳（部署人数10名）。堅苦しい上下関係がなく、困ったときはチャットですぐに相談可能。丁寧なマニュアルとOJTで未経験でも安心してスタートできます。"
      },
      {
        tag: "FEATURE 03",
        title: "話題のAIツールに触れ、<br>市場価値アップ",
        description: "ChatGPT Plus等の有料AIツールアカウントを付与。社内研修ノウハウや動画コンテンツでAIスキルを学び、「AIを使いこなせるバックオフィス人材」へ成長できます。"
      }
    ],
    jobDescriptions: [
      {
        title: "1. AI研修やコンサルティングを受講する企業のデータ入力・受講者リスト管理",
        description: "研修の受講生情報や企業データをスプレッドシートや管理画面へ正確に入力し、最新ステータスを維持します。"
      },
      {
        title: "2. リスキリング助成金等の申請に必要な諸情報の入力・フォーマット管理",
        description: "助成金の申請に必要なフォーマットに沿って指定の情報を整理・入力します。分かりやすいマニュアルが整っています。"
      },
      {
        title: "3. 研修用スライドや営業提案資料（PowerPoint／Googleスライド等）の修正・体裁調整",
        description: "PowerPointやGoogleスライド等の誤字脱字チェック、フォントやレイアウトの体裁を整えるサポートを行います。"
      },
      {
        title: "4. 研修受講後の企業・担当者へ向けた定型文メッセージ（メールやチャット等）の送付",
        description: "受講完了後の案内やアンケート依頼などを、用意されたテンプレート文面に沿ってメールやチャットで送付します。"
      },
      {
        title: "5. 顧客企業のリサーチ（Webサイト等の基本情報収集）および社内への連携",
        description: "顧客企業のWebサイト等の基本情報をインターネット上で収集し、社内の担当チームへ連携します。"
      }
    ],
    workStyles: [
      "就業曜日: 月〜金（週5日・土日祝休み）",
      "私服勤務OK（髪型・ネイル自由）",
      "オンラインの雑談スペースあり（自由参加）"
    ],
    requirements: [
      {
        label: "職種名",
        value: "AI研修・コンサルのサポート事務（データ入力・バックオフィス）",
        type: "text"
      },
      {
        label: "雇用形態",
        value: "契約社員（正社員登用制度あり）または 正社員",
        type: "text"
      },
      {
        label: "給与",
        value: "月給 300,000円〜",
        isHighlighted: true,
        type: "text"
      },
      {
        label: "勤務時間",
        value: "固定時間制 10:00～19:00（休憩60分 / 残業0〜5時間程度）",
        type: "text"
      },
      {
        label: "休日休暇",
        value: "完全週休2日制（土・日・祝）、年間休日120日以上、夏季休暇、年末年始休暇、有給休暇",
        type: "text"
      },
      {
        label: "勤務地",
        value: [
          "完全フルリモート／在宅勤務（日本全国から勤務可能）",
          "本社: 〒107-0061 東京都港区北青山2-7-26 Landwork青山ビル2F（外苑前駅 徒歩2分）※原則出社不要"
        ],
        type: "custom"
      },
      {
        label: "応募資格",
        value: [
          "GoogleスプレッドシートやExcelの基本操作（文字入力・四則演算などの基本関数）ができる方歓迎",
          "PowerPoint等を使った資料作成・修正の経験がある方歓迎",
          "※AIや助成金の専門知識は応募時点で一切不要"
        ],
        type: "list"
      },
      {
        label: "使用ツール・OAスキル",
        value: "Google Workspace、Microsoft Office、LINE、Slack",
        type: "text"
      },
      {
        label: "試用期間",
        value: "試用期間6ヶ月（期間中の条件・待遇に変更はありません）",
        type: "text"
      },
      {
        label: "待遇・福利厚生",
        value: [
          "社会保険完備（雇用・労災・健康・厚生年金）",
          "有給休暇、定期健康診断",
          "話題の生成AIツール（ChatGPT Plus等）のアカウント付与・業務利用OK",
          "服装・髪型・ネイル自由",
          "キャリアアップ支援（社内勉強会・動画コンテンツによるAIスキル習得支援）"
        ],
        type: "checklist"
      },
      {
        label: "受動喫煙防止措置",
        value: "敷地内全て禁煙（完全フルリモート環境）",
        type: "text"
      }
    ],
    selectionSteps: [
      {
        step: "STEP 01",
        title: "「応募する」ボタンからのご応募",
        description: "ページ内のボタンをクリックするとメール画面が立ち上がります。必要事項をご記入の上、履歴書・職務経歴書を添付して応募の旨を送信してください。"
      },
      {
        step: "STEP 02",
        title: "オンライン書類選考（履歴書・職務経歴書）",
        description: "お送りいただいた情報をもとに選考を行います。"
      },
      {
        step: "STEP 03",
        title: "オンライン面接（1〜2回／スマホ・PCから参加OK）",
        description: "スマホやPCから私服でご参加いただけます。業務内容や希望条件のすり合わせを行います。"
      },
      {
        step: "STEP 04",
        title: "内定・就業スタート（最短2週間での入社可能）",
        description: "最短2週間での入社が可能です。就業開始日は柔軟に調整いたします。",
        isLast: true
      }
    ],
    companyProfile: [
      { label: "会社名", value: "株式会社AgLab" },
      { label: "設立", value: "2025年2月7日" },
      { label: "事業内容", value: "AI研修事業、AIコンサル事業、AI開発事業、クリエイティブ制作事業、HR事業" },
      { label: "所在地", value: "〒107-0061 東京都港区北青山2-7-26 Landwork青山ビル2F" },
      { label: "代表電話", value: "03-6434-7778" },
      { label: "公式HP", value: "https://aglab.co.jp/", isLink: true }
    ],
    mailtoSubject: "【求人応募】データ入力・サポート事務（/recruit/1）",
    mailtoBody: "株式会社AgLab 採用担当宛\n\n以下の通り応募いたします。\n\n【氏名】\n【フリガナ】\n【電話番号】\n【メールアドレス】\n【現在の就業状況】\n【自己PR・ご経歴】\n"
  }
];